import * as React from 'react'

const SvgOverflowMenuHorizontalIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm6.25 0a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm6.25 0a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgOverflowMenuHorizontalIcon
